export default __webpack_public_path__ + "static/media/doctor.d4374a83.png";